import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBook, faCode, faCreditCard, faShieldHalved } from "@fortawesome/free-solid-svg-icons";

import { useLanguage } from "../../../context/LanguageProvider";
import Button from "../../../shared/components/elements/Button";

import { COURSE_MESSAGES } from "../messages";
import type { PurchaseCourse } from "../types";
import { formatPrice } from "../utils/price";
import InfoRow from "./InfoRow";

interface PurchasePanelProps {
    course: PurchaseCourse;
    onPay: () => void;
}

// Sticky payment card: summary, price and the pay button
const PurchasePanel = ({ course, onPay }: PurchasePanelProps) => {
    const { lang } = useLanguage();

    return (
        <div className="w-full lg:w-1/3 h-fit sticky top-32 rounded-lg bg-gray-100 mr-auto border-2 border-gray-200 flex flex-col p-2">
            <div className="w-full p-5 border-b-2 border-gray-200">
                <h2 className="text-2xl font-bold">{COURSE_MESSAGES.purchase}</h2>
            </div>

            <InfoRow label={COURSE_MESSAGES.course} value={course.title} />
            <InfoRow label={COURSE_MESSAGES.lessonsShort} value={course.lessons ?? 0} icon={faBook} />
            <InfoRow label={COURSE_MESSAGES.projectsShort} value={course.projects ?? 0} icon={faCode} />
            <InfoRow label={COURSE_MESSAGES.gateway} value={COURSE_MESSAGES.zarinpal} icon={faCreditCard} />

            <div className="p-5">
                <span className="block text-gray-600 mb-2">{COURSE_MESSAGES.payable}</span>
                <div className="flex items-center gap-2">
                    <strong className="text-3xl">{formatPrice(course.price, lang)}</strong>
                    <span>{COURSE_MESSAGES.toman}</span>
                </div>
            </div>

            <Button className="w-full m-2" onClick={onPay}>
                <FontAwesomeIcon icon={faShieldHalved} className="ml-2" />
                {COURSE_MESSAGES.payAndStart}
            </Button>

            <div className="flex items-center gap-2 text-sm text-gray-500 p-4">
                <FontAwesomeIcon icon={faShieldHalved} />
                <span>{COURSE_MESSAGES.securePayment}</span>
            </div>
        </div>
    );
};

export default PurchasePanel;